import { Modal } from "react-bootstrap";
import React from "react";
import { ReactComponent as Whiteclose } from "../../assets/images/white-close.svg";

class ImageModal extends React.Component {
  render() {
    return (
      <Modal
        show={this.props.show}
        onHide={this.props.hideModal}
        backdrop="static"
        keyboard={false}
        centered
        id="video-modal"
      >
        <div className="video-modal">
          <div className="modal-close">
            <Whiteclose className="closeicon" onClick={this.props.hideModal} />
          </div>
          <img src={this.props.source} className="image-modal" alt="" />
        </div>
      </Modal>
    );
  }
}

export default ImageModal;
